import axios from 'axios'
import store from '@/store'
import storage from 'store'
import notification from 'ant-design-vue/es/notification'
import message from 'ant-design-vue/es/message'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tansParams, blobValidate } from '@/utils/ruoyi'
import cache from '@/plugins/cache'
import errorCode from '@/utils/errorCode'
import qs from 'qs'
import { saveAs } from 'file-saver'
import { h } from 'vue'
import { LoadingOutlined } from '@ant-design/icons-vue'

// 是否显示重新登录
let isReloginShow
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_BASE_API || '/dev-api',
  timeout: 100000, // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  console.error('请求错误:', error)
  console.error('错误详情:', {
    message: error.message,
    code: error.code,
    config: error.config,
    response: error.response,
  })
  
  let { message } = error
  let description = ''
  
  // 处理跨域错误
  if (error.code === 'ERR_NETWORK' || message === 'Network Error') {
    message = '网络连接失败'
    description = '请检查：1. 后端服务是否启动 2. 代理配置是否正确 3. 是否存在跨域问题'
  } else if (error.code === 'ECONNABORTED' || message.includes('timeout')) {
    message = '系统接口请求超时'
    description = '请求超时，请稍后重试或检查网络连接'
  } else if (error.response) {
    // 服务器返回了错误响应
    const status = error.response.status
    const statusText = error.response.statusText || ''
    message = `请求失败 (${status} ${statusText})`
    
    if (status === 0) {
      description = '可能是跨域问题，请检查代理配置或后端 CORS 设置'
    } else if (status === 404) {
      description = '接口不存在，请检查 API 地址是否正确'
    } else if (status === 500) {
      description = '服务器内部错误，请稍后重试'
    } else if (status === 403) {
      description = '没有权限访问该资源'
    } else if (status === 401) {
      description = '未授权，请重新登录'
    } else {
      description = error.response.data?.message || error.response.data?.msg || statusText
    }
  } else if (message.includes('Request failed with status code')) {
    message = '系统接口' + message.substr(message.length - 3) + '异常'
  } else if (error.message) {
    message = error.message
  } else {
    message = '未知错误'
    description = '请查看控制台获取更多信息'
  }
  
  notification.error({
    message: message,
    description: description,
    duration: 5 * 1000,
  })
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use((config) => {
  const token = storage.get(ACCESS_TOKEN)
  // 是否需要防止数据重复提交
  const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义token 请根据实际情况自行修改
    // config.headers['accessAccess-Token'] = token
  }
  // 处理params参数
  if (config.params && Object.keys(config.params).length > 0) {
    // 调试：打印请求信息
    if (config.url.includes('/dict/data/')) {
      console.log('=== Request Interceptor ===')
      console.log('原始 URL:', config.url)
      console.log('params:', config.params)
    }
    const url =
      config.url + '?' + qs.stringify(config.params, { indices: false })
    config.params = {}
    config.url = url
    if (config.url.includes('/dict/data/')) {
      console.log('处理后 URL:', config.url)
      console.log('==========================')
    }
  }
  if (
    !isRepeatSubmit &&
    (config.method === 'post' ||
      config.method === 'put' ||
      config.method === 'delete')
  ) {
    const requestObj = {
      url: config.url,
      data:
        typeof config.data === 'object'
          ? JSON.stringify(config.data)
          : config.data,
      time: new Date().getTime(),
    }
    const sessionObj = cache.session.getJSON('sessionObj')
    if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
      cache.session.setJSON('sessionObj', requestObj)
    } else {
      const s_url = sessionObj.url // 请求地址
      const s_data = sessionObj.data // 请求数据
      const s_time = sessionObj.time // 请求时间
      const interval = 1000 // 间隔时间(ms)，小于此时间视为重复提交
      if (
        s_data === requestObj.data &&
        requestObj.time - s_time < interval &&
        s_url === requestObj.url
      ) {
        const message = '数据正在处理，请勿重复提交'
        console.warn(`[${s_url}]: ` + message)
        return Promise.reject(new Error(message))
      } else {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((res) => {
  console.log('响应数据', res)
  // 请求rul
  const requestUrl = res.config.url
  // 未设置状态码则默认成功状态
  const code = res.data.code || '20001'
  // 获取错误信息
  const msg =
    errorCode[code] || res.data.message || res.data.msg || errorCode['default']
  // 二进制数据则直接返回
  if (
    res.request.responseType === 'blob' ||
    res.request.responseType === 'arraybuffer'
  ) {
    return res.data
  }
  if (code === 401 || code === 'U0231' || code === 'U0230') {
    if (!isReloginShow) {
      isReloginShow = true
      notification.error({ message: '登录状态已过期，请重新登录' })
      setTimeout(() => {
        store.dispatch('Logout').then(() => {
          isReloginShow = false
          location.href = '/index'
        })
      }, 500)
    }
    return Promise.reject(new Error(msg || '未授权'))
  }
  if (code === 500) {
    if (requestUrl !== '/login') {
      notification.error({
        message: msg,
        description: msg,
      })
    }
    return Promise.reject(new Error(msg || '服务器错误'))
  }
  if (code === 601) {
    notification.error({ message: msg })
    return Promise.reject(new Error(msg || 'error'))
  }
  if (code === '40000' || code === 'U0200' || code === 'U0210') {
    notification.error({ message: msg })
    return Promise.reject(new Error(msg || 'error'))
  }
  if (code !== '20001' && code !== 1) {
    notification.error({ message: msg })
    return Promise.reject(new Error(msg || 'error'))
  }
  return res.data
}, errorHandler)

const installer = {
  vm: {},
  install(Vue) {
    window.$vueApp.use(VueAxios, request)
  },
}

// 通用下载方法
export function download(url, params, filename) {
  const notificationKey = 'download'
  notification.open({
    key: notificationKey,
    message: '正在下载数据，请稍候',
    duration: null,
    icon: () => {
      return h(LoadingOutlined, {
        spin: true,
      })
    },
  })
  return request
    .post(url, params, {
      transformRequest: [
        (params) => {
          return qs.stringify(params, { indices: false })
        },
      ],
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      responseType: 'blob',
    })
    .then(async (data) => {
      const isLogin = await blobValidate(data)
      if (isLogin) {
        const blob = new Blob([data])
        saveAs(blob, filename)
        message.success('下载成功')
      } else {
        const resText = await data.text()
        const rspObj = JSON.parse(resText)
        const errMsg =
          errorCode[rspObj.code] || rspObj.msg || errorCode['default']
        message.error(errMsg)
      }
      notification.close(notificationKey)
    })
    .catch((r) => {
      message.error('下载文件出现错误，请联系管理员！')
      notification.close(notificationKey)
    })
}

export default request

export { installer as VueAxios, request as axios }
